import { render, staticRenderFns } from "./AbousUsSection.vue?vue&type=template&id=51da03ea"
import script from "./AbousUsSection.vue?vue&type=script&lang=js"
export * from "./AbousUsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports